import CustomFieldsCollapse from "components/shared/CustomFieldsCollapse";
import DateFormComponent from "components/shared/FormComponent/DateFormComponent";
import PriceFormComponent from "components/shared/FormComponent/PriceFormComponent";
import { PortalType } from "contexts/portal.context";
import { usePermissions } from "hooks/usePermissions";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import type { ICustomField } from "store/customFieldsStore";

import type { TPublicationFormData } from "..";

interface ICalculationMethodStep {
    stepTitle: string;
    stepSubtitle: string;
    mode: "new" | "edit-page";
    indexStep: number;
    useFormData: TPublicationFormData;
    calculationMethod: { isFolioBased: boolean; usesBothCalculationMethods: boolean };
    customFields: ICustomField[];
}

const CalculationMethodStep = ({
    stepTitle,
    stepSubtitle,
    mode,
    indexStep,
    useFormData,
    calculationMethod,
    customFields,
}: ICalculationMethodStep) => {
    const [t] = useTranslation();
    const { control, errors } = useFormData;
    const { isFolioBased, usesBothCalculationMethods } = calculationMethod;
    const { hasPermissions } = usePermissions();
    const portalType = useContext(PortalType);

    // Filter fields that should not appear on creation :
    const customFieldsOnCreation = customFields.filter((field) => field.showOnCreation);

    return (
        <>
            <h3 className="form-section-title first">
                {" "}
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                {(isFolioBased || usesBothCalculationMethods) && (
                    <div className="folio-block">
                        <PriceFormComponent
                            label={t("NewPublication.PricePerFolio")}
                            placeholder={t("NewPublication.PricePerFolioPlaceholder")}
                            control={control}
                            controlName="pricePerFolio"
                            error={errors.pricePerFolio}
                            required={isFolioBased}
                            customRequiredMessage={t(`NewPublication.RequiredPrice_${portalType}`)}
                            disabled={!hasPermissions(["publication:new"])}
                        />
                        {usesBothCalculationMethods && (
                            <span className="folio-info">{t("NewPublication.FolioInfo")}</span>
                        )}
                    </div>
                )}
                <DateFormComponent
                    label={t("NewPublication.DeliveryDate")}
                    control={control}
                    controlName="deliveryDate"
                    error={errors.deliveryDate}
                    disabled={!hasPermissions(["publication:new"])}
                />
                <DateFormComponent
                    label={t("NewPublication.ReleaseDate")}
                    control={control}
                    controlName="releaseDate"
                    error={errors.releaseDate}
                    disabled={!hasPermissions(["publication:new"])}
                />
                {/** COLLAPSE FOR THE CUSTOM FIELDS */}
                {customFields.length > 0 && (
                    <CustomFieldsCollapse
                        sectionFields={mode === "new" ? customFieldsOnCreation : customFields}
                        errors={errors}
                        mode={mode}
                    />
                )}
            </div>
        </>
    );
};

export default CalculationMethodStep;
